import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';

import { tariffNames, tariffNamesWithoutFeeACHAndCC } from '../../utils/additionalServices';
import { LIST_PAYMENTS_TYPE } from '../../utils/listPaymentsType';

import roleConfig from '../../configs/roles';

import paymentsRemote from '../../api/paymentsRemote';
import forwarderRemote from '../../api/forwarderRemote';
import ghaRemote from '../../api/ghaRemote';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import CompanyModel from '../../models/ForwarderAwb';
import { PaymentAwbReport, PaymentReport } from '../../models/PaymentReport';
import User from '../../models/User';

import Button from '@material-ui/core/Button';

import moment, { Moment } from 'moment';

import style from '../cart/cart.module.css';
import commonStyles from '../common/common.module.css';

import PaymentReportTable from './PaymentReportTable';
import PaymentReportSearch from './PaymentReportSearch';
import PaymentReportHeaderPrint from './PaymentReportHeaderPrint';
import userManagementReqHandler from '../../api/userManagementRemote';
import AirlineType from '../../models/AirlineType';
import AwbInfoSearchComponent from '../awbInfo/awbInfoSearch/AwbInfoSearchComponent';
import { ExportToCsv } from 'export-to-csv';
import PaymentNote from './PaymentNote';
import PaymentAuditContainer from './paymentAudit/PaymentAuditContainer';
import { PaymentType } from '../../models/PaymentType.enum';
import { baseUrl } from '../../api/baseUrl';

interface PaymentReportWrapperProps {
  user: User;
  receiveError: (error: ResponseError) => void;
  buttonState: boolean;
};

interface PaymentReportWrapperState { 
  payments: PaymentReport;
  startDate: Moment;
  endDate: Moment;
  awbNumber: string;
  selectedCompanyID: number;
  valuePaymentType: string;
  selectedFeeType: Array<string>;
  searchCompanyList: Array<CompanyModel>;
  printMode: boolean;
  view: string;
  airlineValue: string;
  listFeeType: Array<{value: string, name: string }>;
  airlines: AirlineType[];
  remarksModal: boolean;
  remarksAwb: string;
  awbVersion: number;
  selectedRemark: string;
  selectedPayment: number;
  settled: boolean;
  auditModal: boolean;
  payment?: PaymentAwbReport;
  overpaid: boolean;
  underpaid: boolean;
  otherPaymentType: string;
  paymentType: string;
  progressBar: boolean;
};

class PaymentReportWrapperContainer extends Component <PaymentReportWrapperProps, PaymentReportWrapperState> {

  state: PaymentReportWrapperState = {
    payments: {
      total: 0,
      awbs: [],
      count: 0,
      totalCollectedAmount: 0,
      balanceDue: 0
    },
    startDate: moment(),
    endDate: moment(),
    selectedCompanyID: 0,
    searchCompanyList: [],
    valuePaymentType: 'all',
    selectedFeeType:[],
    printMode: false,
    view: 'render',
    listFeeType: [],
    airlines: [],
    airlineValue: '',
    awbNumber: '',
    remarksModal: false,
    remarksAwb: '',
    selectedRemark: '',
    selectedPayment: -1,
    settled: false,
    auditModal: false,
    payment: {} as PaymentAwbReport,
    underpaid: false,
    overpaid: false,
    otherPaymentType: '',
    paymentType: 'all',
    awbVersion: 0,
    progressBar: false
  }
    
  componentDidMount() {

    let listFeeType: Array<{ value: string, name: string }>;

    if (this.props.user.roleId === roleConfig.roleId.forwarderUser) {
      this.loadGhas();
      listFeeType = Object.keys(tariffNames).map((key: string) => ({ value: key, name: tariffNames[key] }));
    } else {
      this.getGhaAirlines();
      this.loadForwarders();
      listFeeType = Object.keys(tariffNamesWithoutFeeACHAndCC).map((key) => ({ value: key, name: tariffNamesWithoutFeeACHAndCC[key] }));
    };

    const selectedFeeType: Array<string> = listFeeType.map(x=> x.value);
    this.setState({ selectedFeeType, listFeeType });
    this.subscribeToPayment();
  };

  loadForwarders = (): void => {
    forwarderRemote.getForwarders({}).then((resp: ApiResponse<Array<CompanyModel>>) => {
      
      const listForwarders : Array<CompanyModel> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (listForwarders) {
        this.setState({ searchCompanyList: listForwarders });
      };
      
      if (error) {
        this.props.receiveError(error);
      };
    }).then (()=> {
      this.loadPayments();
    });
  };

  subscribeToPayment = (): void => {
    const payment = new EventSource(baseUrl + `events?type=payment`, {
      withCredentials: true
    });

    payment.onmessage = (event) => {

      const parsedData = JSON.parse(event.data);
      if(parsedData && parsedData.awbs && parsedData.awbs.length > 0) {
        const awb = parsedData.awbs[0];
        this.setState((prevState) => {
          const payments = { ...prevState.payments };
          if(payments) {
            const awbs = [...payments.awbs]; // Create a copy of the existing awbs array
    
            const existingAwbIndex = awbs.findIndex((existingAwb) => existingAwb.code === awb.code &&  existingAwb.number === awb.number);
      
            if (existingAwbIndex !== -1) {
              const previousAwb = prevState.payments.awbs[existingAwbIndex];
              awbs[existingAwbIndex] = awb;
              
              const newTotal = (awb.payments && awb.payments.length > 0) ? awb.payments[0].total : 0;
              const oldTotal = (previousAwb.payments && previousAwb.payments.length > 0) ? previousAwb.payments[0].total : 0;
              
              payments.total += (newTotal - oldTotal);
              payments.balanceDue += ((awb.balance || 0) - (previousAwb.balance || 0));
              payments.totalCollectedAmount += ((awb.amount_collected || 0) - (previousAwb.amount_collected || 0));
            } else {
              awbs.push(awb);
              const newTotal = (awb.payments && awb.payments.length > 0) ? awb.payments[0].total : 0;
              payments.total += newTotal;
              payments.balanceDue += (awb.balance || 0);
              payments.totalCollectedAmount += (awb.amount_collected || 0);
              payments.count = awbs.length;
            }
            payments.awbs = awbs;
          } // Create a copy of the existing payments object

    
          return { payments };
        });
      }

    }

    payment.onerror = (error) => {

      if (error.type === 'error') {

      }

    }
  }

  getGhaAirlines = (ghaId?: number) => {
    userManagementReqHandler.getAirlines(ghaId).then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ airlines: airlines });
      }
    })
  }

  saveRemarks = () => {
    paymentsRemote.addRemarks(this.state.selectedPayment, this.state.selectedRemark).then(resp => {
      const result: boolean | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(result) {
        this.handleCloseModal('orderNote');
        this.loadPayments();
      }
    })
  } 

  saveSettlement = (id: number, value: boolean) => {
    paymentsRemote.settlePayment(id, value).then(resp => {
      const result: boolean | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(result) {
        // this.loadPayments();
      }
    })
  } 

  settlePayment = () => {
    const payments = {...this.state.payments};
    let boolValue: boolean = false;
    let payment: any;
    payments.awbs.forEach(element => {
      if(element.payment_id === this.state.selectedPayment) {
        element.settled = !element.settled;
        payment = element;
        boolValue = element.settled;
      }
    });
    this.setState({ payments, payment }, () => {
      this.saveSettlement(this.state.selectedPayment, boolValue);
    });
  }

  loadGhas = (): void => {
    ghaRemote.getGHAs().then((resp: ApiResponse<Array<CompanyModel>>) => {

      const listGhas: Array<CompanyModel> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (listGhas) {
        this.setState({ searchCompanyList: listGhas });     
      };
      
      if (error) {
        this.props.receiveError(error);
      };
    }).then (()=> {
      this.loadPayments();
    });
  };

  loadPayments = (): void => {
    this.setState({ progressBar: true, payments: { total: 0, awbs: [], count: 0, totalCollectedAmount: 0, balanceDue: 0 } }, () => {
      this.fetchBatch(0, 100);
    });
  }

  fetchBatch = (offset: number, limit: number): void => {
    const startDate: string = this.state.startDate ? this.state.startDate.format('YYYYMMDD') : '';
    const endDate: string = this.state.endDate ? this.state.endDate.format('YYYYMMDD') : '';
    const paymentMethod: string | undefined = this.state.paymentType === 'all' ? undefined :  this.state.paymentType;
    const alternativePaymentMethod: string | undefined = this.state.otherPaymentType === '' ? undefined :  this.state.otherPaymentType;
    const services: Array<string> = this.state.selectedFeeType;
    let fwdId: number = 0;
    let ghaId: number = 0;

    this.props.user.roleId === roleConfig.roleId.forwarderUser ? ghaId = this.state.selectedCompanyID : fwdId = this.state.selectedCompanyID

    paymentsRemote.getPaymentsByFwdOrGha(services, {
      fwdId, ghaId, startDate, endDate, paymentMethod: paymentMethod, 
      alternativePaymentMethod: alternativePaymentMethod, airlineId: this.state.airlineValue, 
      awbNumber: this.state.awbNumber, settled: this.state.settled, 
      overpaid: this.state.overpaid, underpaid: this.state.underpaid, limit, offset 
    }).then((resp: ApiResponse<PaymentReport>) => {

      const payments: PaymentReport | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      
      if (payments) {
        this.setState((prevState) => {
          const currentAwbs = [...prevState.payments.awbs];
          payments.awbs.forEach((newAwb) => {
            const existingIdx = currentAwbs.findIndex(a => a.code === newAwb.code && a.number === newAwb.number);
            if (existingIdx !== -1) {
              currentAwbs.push(newAwb);
            } else {
              currentAwbs.push(newAwb);
            }
          });

          return {
            payments: {
              total: prevState.payments.total + payments.total,
              count: currentAwbs.length,
              totalCollectedAmount: prevState.payments.totalCollectedAmount + payments.totalCollectedAmount,
              balanceDue: prevState.payments.balanceDue + payments.balanceDue,
              awbs: currentAwbs
            }
          };
        }, () => {
          if (payments.hasMore) {
            this.fetchBatch(offset + limit, limit);
          } else {
            this.setState({ progressBar: false });
          }
        });
      } else {
        this.setState({ progressBar: false });
      }
      
      if (error) {
        this.setState({ progressBar: false });
        this.props.receiveError(error);
      };
    });
  }

  exportCsv = (): void => {
    
    const data = this.state.payments.awbs.map(({...awb}: any, i) => {
      let payment_method: string = '', payment_source : string = '';
      awb.post_delivery_adjustment = 0;
      for(let i = 0; i < awb.adjustments.length; i++) {
        const adjust = awb.adjustments[i];
        awb.post_delivery_adjustment += Number(adjust.amount);
      }
      awb.payments.map((service: any , index: number) => {
        awb.import_service = 0;
        awb.storage_fee = 0;
        awb.gha_adjust = 0;
        awb.other = 0;
        awb.comat = 0;
        awb.copa_comat = 0;
        awb.nomination_fee = 0;
        for(let i = 0; i < awb.payments[0].services.length; i++) {
          const serv = awb.payments[0].services[i];
          if(serv.service === "import_service") {
            awb.import_service = serv.amount;
            continue;
          }
          if(serv.service === "storage_fee") {
            awb.storage_fee = serv.amount;
            continue;
          }
          if(serv.service === "nomination_fee") {
            awb.nomination_fee = serv.amount;
            continue;
          }
          if(serv.service === "copa_comat" || serv.service === "copa") {
            awb[serv.service] = serv.amount;
            continue;
          }
          if(serv.service === "gha_adjust") {
            awb.gha_adjust += serv.amount;
            continue;
          }
          awb.other += serv.amount;
        };
        payment_method = service.payment_method;
        payment_source = service.services.length ? service.services[0].reason.manualReason : '';
      });

      awb.total_charges = awb.total
      delete awb.total;
      awb.payment_method = payment_method;
      awb.payment_source = payment_source;
      delete awb.payments;
      delete awb.tableData;
      delete awb.payment_id;
      delete awb.code;
      delete awb.number;
      delete awb.adjustments;
      return awb;
    });
    const options = { 
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true, 
      showTitle: true,
      title: 'Payment Report CSV',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(data);
  }
   
  showSettledPayments = (type: string): void => {
    const payments = {...this.state.payments};
    switch (type) {
      case 'audit':
        this.setState({ payments, settled: !this.state.settled }, () => {
          this.loadPayments();
        });
        break;
      case 'underpaid':
        this.setState({underpaid: !this.state.underpaid }, () => {
          this.loadPayments();
        });
        break;
      case 'overpaid':
        this.setState({ overpaid: !this.state.overpaid }, () => {
          this.loadPayments();
        });
        break;
      default:
        break;
    }
    
  }

  handleChangeAwb = (event: any): void => {
    let value: string = event.target.value.toString();
    if (value.length === 3 && this.state.awbNumber.length === 2) {
      value = value + "-";
    }
    if (value.length === 11) {
      if (value.indexOf("-") < 0) {
        value = value.slice(0, 3) + "-" + value.slice(3);
      }
    }
    if (value.split("-").length > 2) {
      value = value;
    }
    this.setState({ awbNumber: value });
  };

  handleChangeDate = (type: string, date: Moment): void => {

    switch (type) {
      case 'startDate': this.setState({ startDate: date });
        break;
      case 'endDate': this.setState({ endDate: date });
        break;
      default: break;
    };
  };

  changeRemarks = (event: any): void => {
    const payments = {...this.state.payments};
    let remarks = this.state.selectedRemark;
    remarks = event.target.value;
    this.setState({ selectedRemark: remarks });
  }

  handleCloseModal = (modalType: string): void => {
    switch(modalType) {
      case 'orderNote' : this.setState({remarksModal: false, remarksAwb:' '}); break;
      case 'audit' : 
        this.setState({auditModal: false});
        break;
      default: break;
    }
  }

  handleOpenModal = (modalType: string, id: number, awbNumber : string, awbVersion: number, remarks?: string, payment?: PaymentAwbReport) : void => {
    switch(modalType) {
      case 'orderNote' : this.setState({remarksModal: true, remarksAwb: awbNumber ? awbNumber: '', selectedRemark: remarks ? remarks: '', selectedPayment: id}); break;
      case 'audit' : this.setState({auditModal: true, remarksAwb: awbNumber ? awbNumber: '', selectedPayment: id, payment: payment, awbVersion}); break;
      default: break;
    }
  }

  handleChangeSelectOption = (event: any, type: string): void => {
    
    let value: any;
    if (type === 'companies') {
      value = event ? event.value : '';
    } else {
      value = event.target.value;
    }
    switch (type) {
      case 'companies' : this.setState({ selectedCompanyID: value}, () => {
        if (this.props.user.roleId === roleConfig.roleId.forwarderUser && value) {
          this.getGhaAirlines(value);
        }
      });
        break;
      case 'paymentType' :
        let otherPaymentType = '';
        let valuePaymentType = value;
        let paymentType = value;
        if(value === 'Cargo Sprint' || value === 'Pay Cargo' || value === 'Cheque' || value === 'Cash') {
          otherPaymentType = value;
          paymentType = PaymentType.ALTERNATIVE_PAYMENT;
        }
        this.setState({ valuePaymentType, otherPaymentType, paymentType });
        break;
      case 'airline' : this.setState({ airlineValue : value});
        break;
      default: return;
    }
  }

  handleChangeFeeType = (event: any ): void => {

    const values = event.target.value;
    let selectedFeeType = this.state.selectedFeeType;

    if (values.includes('select all')) {
      if (this.props.user.roleId === roleConfig.roleId.forwarderUser) {
        selectedFeeType = Object.keys(tariffNames);
      } else {
        selectedFeeType = Object.keys(tariffNamesWithoutFeeACHAndCC);
      }
    } else if (values.includes('deselect all')) {
      selectedFeeType = [];
    } else {
      selectedFeeType = values;
    }
    this.setState({ selectedFeeType });
  };

    
  
  print = (): void => {
    this.setState({ view: 'print'}, ()=> {
      window.print();
      this.setState({ view: 'render'});
    });
  }

  render() {

    const companyName: string = this.state.searchCompanyList.filter((company: CompanyModel) => company.id === Number(this.state.selectedCompanyID)).map(x=> x.name)[0];
    const paymentTypeName: string = LIST_PAYMENTS_TYPE.filter((type: { value: string, name: string }) => type.value === this.state.valuePaymentType).map(x=> x.name)[0];

    return (
      <div>
        <div className= { commonStyles.headerDummyDiv }> </div>
        <div className={ [commonStyles.searchWrapperOuter, style.screeningDetails].join(" ") }>
            <AwbInfoSearchComponent
              awbNumber={this.state.awbNumber}
              label = 'AirwayBill'
              handleChangeAwbNumber={this.handleChangeAwb}
              search={ this.loadPayments }
              type='screening'
              buttonState={ this.props.buttonState }
            />
        </div>
        { this.state.view === 'render' &&
          <PaymentReportSearch
            userId={ this.props.user.roleId }
            startDate={ this.state.startDate }
            endDate={ this.state.endDate}
            progressBar={ this.state.progressBar }
            companyID={ this.state.selectedCompanyID }
            listCompanies={ this.state.searchCompanyList }
            handleChangeDate={ this.handleChangeDate }
            handleChangeSelectOption={ this.handleChangeSelectOption }
            search={ this.loadPayments }
            listPaymentType={ LIST_PAYMENTS_TYPE }
            listFeeType={ this.state.listFeeType }
            valuePaymentType={ this.state.valuePaymentType }
            selectedFeeType={ this.state.selectedFeeType }
            handleChangeFeeType={ this.handleChangeFeeType }
            airlineValue={ this.state.airlineValue }
            airlines={ this.state.airlines }
            settled={ this.state.settled }
            settledPayments={ this.showSettledPayments }
            underpaid={ this.state.underpaid }
            overpaid={ this.state.overpaid }
          />
        }

        { this.state.view === 'print' &&
          <PaymentReportHeaderPrint
            userId={ this.props.user.roleId }
            companyName={ companyName }
            startDate={ this.state.startDate }
            endDate={ this.state.endDate }
            paymentType={ paymentTypeName }
            selectedFeeType={ this.state.selectedFeeType }
          />
        }
       
        <PaymentReportTable
          payments={ this.state.payments }
          view={ this.state.view }
          loading={ this.state.progressBar }
          changeRemarks={ this.changeRemarks }
          openRemarks={ this.handleOpenModal }
          changeSettled={ this.settlePayment }
          exportCsv={ this.exportCsv }
        />

        {
        this.state.remarksModal && <PaymentNote
          note={ this.state.selectedRemark }
          awbNumber={ this.state.remarksAwb }
          handleClose={ this.handleCloseModal }
          onChangeRemark={ this.changeRemarks }
          saveRemark={ this.saveRemarks }
        />
        }
        {
        this.state.auditModal && <PaymentAuditContainer
          awbNumber={ this.state.remarksAwb }
          handleClose={ this.handleCloseModal }
          paymentId={ this.state.selectedPayment }
          changeSettled={ this.settlePayment }
          payment={ this.state.payment }
          awbVersion={ this.state.awbVersion }
          auditModal={ this.state.auditModal }
          startDate={ this.state.startDate }
          endDate={ this.state.endDate }
        />
        }
         <div>
          { this.state.view === 'render' &&
            <div className={ style.btnWrapper}>
              <Button  
                color="primary" 
                variant="contained"
                onClick={ () => this.print() } 
                className={ style.button } 
              >
                Print
            </Button>
            </div>
          }
         </div>
      </div>
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    buttonState: state.buttonState
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentReportWrapperContainer);